<template>
  <div>
    <v-data-table
      :headers="customerRepairItemDataTableHeaders"
      :items="customerRepairItems"
      class="elevation-1 ma-5 "
      :search="searchCustomerRepairItem"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchCustomerRepairItem"
            append-icon="mdi-magnify"
            :label="$t('customer_repair_item_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            v-if="viewName === 'update-many'"
            color="primary"
            :disabled="isAllTextFieldDisable"
            class="ml-5"
            @click="isShowEditCustomerRepairItemDialog = true"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowEditCustomerRepairItemDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_edit') }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="repairItem">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <new-item-autocomplete
                          :fatherEditedItem="editedCustomerRepairItem"
                          :editedItemIndex="editedCustomerRepairItemIndex"
                          :itemName="'customer_repair_item_new_number'"
                          @setEditedItem="setEditedItem"
                          :isAllTextFieldDisable="isAllTextFieldDisable"
                          v-if="
                            editedCustomerRepairItemIndex === -1 &&
                              isShowEditCustomerRepairItemDialog
                          "
                          refName="itemAutocomplete"
                          @keyupEnter="focusNextInput"
                        />
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.Number"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.Name"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_warranty_period')"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.WarrantyPeriod"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_warranty_period') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_price')"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.Price"
                            @change="turnOldPrice"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_price') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="新品維修保固"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.RepairWarrantyPeriod"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              新品維修保固
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="新品維修價格"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.RepairPrice"
                            @change="turnOldRepairPrice"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              新品維修價格
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairItem.OldNumber"
                          :label="$t('customer_repair_item_old_number')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairItem.OldName"
                          :label="$t('customer_repair_item_old_name')"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_old_warranty_period')"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.OldWarrantyPeriod"
                            :label="$t('customer_repair_item_old_warranty_period')"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_old_price')"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.OldPrice"
                            :label="$t('customer_repair_item_old_price')"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="良品維修保固"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.OldRepairWarrantyPeriod"
                            label="良品維修保固"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="良品維修價格"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairItem.OldRepairPrice"
                            label="良品維修價格"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <ValidationProvider name="變更原因" rules="required" v-slot="{ errors }">
                          <v-textarea
                            outlined
                            v-model="editedCustomerRepairItem.Reason"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              變更原因
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedCustomerRepairItem"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="addEditedCustomerRepairItem">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteCustomerRepairItemDialog"
            :deleteMessage="'item_group_delete_dialog_message'"
            @closeDelete="closeCustomerRepairItem"
            @confirmDelete="confirmDeleteCustomerRepairItem"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          @click="isShowEditCustomerRepairItemDialogBtn(item)"
          :disabled="isAllTextFieldDisable"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="isShowDeleteCustomerRepairItemDialogBtn(item)"
          :disabled="isAllTextFieldDisable"
        >
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.OldRepairPrice`]="{ item }">
        {{ appearPrice(item.OldRepairPrice) }}
      </template>
      <template v-slot:[`item.OldWarrantyPeriod`]="{ item }">
        {{ appearWarrantyPeriod(item.OldWarrantyPeriod) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import NewItemAutocomplete from '@/components/NewItemAutocomplete.vue'
export default {
  components: { NewItemAutocomplete, DeleteDialog },
  props: {
    viewName: {
      type: String
    },
    customerRepairItems: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    }
  },
  name: 'UpdateCustomerRepairItem',
  data: () => ({
    isLoadingSaveBtn: false,
    searchCustomerRepairItem: '',
    editedCustomerRepairItem: {
      ItemId: '',
      Number: '',
      Name: '',
      Price: 0,
      WarrantyPeriod: 0,
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      OldItemId: '',
      OldNumber: '',
      OldName: '',
      OldPrice: 0,
      OldWarrantyPeriod: 0,
      OldRepairPrice: 0,
      OldRepairWarrantyPeriod: 0,
      Reason: ''
    },
    defaultCustomerRepairItem: {
      ItemId: '',
      Number: '',
      Name: '',
      Price: 0,
      WarrantyPeriod: 0,
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      OldItemId: '',
      OldNumber: '',
      OldName: '',
      OldPrice: 0,
      OldWarrantyPeriod: 0,
      OldRepairPrice: 0,
      OldRepairWarrantyPeriod: 0,
      Reason: ''
    },
    isShowEditCustomerRepairItemDialog: false,
    isShowDeleteCustomerRepairItemDialog: false,
    editedCustomerRepairItemIndex: -1
  }),
  mounted () {},
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairItemDataTableHeaders () {
      return [
        { text: this.$t('customer_repair_item_new_number'), align: 'start', value: 'Number' },
        { text: this.$t('customer_repair_item_new_name'), align: 'start', value: 'Name' },
        {
          text: this.$t('customer_repair_item_new_warranty_period'),
          align: 'end',
          value: 'WarrantyPeriod'
        },
        { text: this.$t('customer_repair_item_new_price'), align: 'end', value: 'Price' },
        { text: '新品維修保固期數', align: 'end', value: 'RepairWarrantyPeriod' },
        { text: '新品維修價格', align: 'end', value: 'RepairPrice' },
        { text: this.$t('customer_repair_item_old_number'), align: 'start', value: 'OldNumber' },
        { text: this.$t('customer_repair_item_old_name'), align: 'start', value: 'OldName' },
        {
          text: this.$t('customer_repair_item_old_warranty_period'),
          align: 'end',
          value: 'OldWarrantyPeriod'
        },
        {
          text: this.$t('customer_repair_item_old_price'),
          align: 'end',
          value: 'OldPrice'
        },
        {
          text: '良品維修保固期數',
          align: 'end',
          value: 'OldRepairWarrantyPeriod'
        },
        {
          text: '良品維修價格',
          align: 'end',
          value: 'OldRepairPrice'
        },
        { text: '變更原因', align: 'start', value: 'Reason' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    appearPrice (oldRepairPrice) {
      if (oldRepairPrice !== 0) {
        return oldRepairPrice
      } else {
        return ''
      }
    },
    appearWarrantyPeriod (oldWarrantyPeriod) {
      if (oldWarrantyPeriod !== 0) {
        return oldWarrantyPeriod
      } else {
        return ''
      }
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async addEditedCustomerRepairItem () {
      const isValid = await this.$refs.repairItem.validate()
      if (isValid) {
        this.$emit('setEditedCustomerRepairItemIndex', this.editedCustomerRepairItemIndex)
        this.$emit('addEditedCustomerRepairItem', this.editedCustomerRepairItem)
        this.closeEditedCustomerRepairItem()
      }
    },
    async closeEditedCustomerRepairItem () {
      this.isShowEditCustomerRepairItemDialog = false
      this.$nextTick(() => {
        this.editedCustomerRepairItem = JSON.parse(JSON.stringify(this.defaultCustomerRepairItem))
        this.editedCustomerRepairItemIndex = -1
      })
    },
    isShowEditCustomerRepairItemDialogBtn (item) {
      this.editedCustomerRepairItemIndex = this.customerRepairItems.indexOf(item)
      this.editedCustomerRepairItem = JSON.parse(JSON.stringify(item))
      this.isShowEditCustomerRepairItemDialog = true
    },

    isShowDeleteCustomerRepairItemDialogBtn (item) {
      this.editedCustomerRepairItemIndex = this.customerRepairItems.indexOf(item)
      this.isShowDeleteCustomerRepairItemDialog = true
    },
    confirmDeleteCustomerRepairItem () {
      this.$emit('confirmDeleteCustomerRepairItem', this.editedCustomerRepairItemIndex)
      this.closeCustomerRepairItem()
    },

    closeCustomerRepairItem () {
      this.isShowDeleteCustomerRepairItemDialog = false
      this.$nextTick(() => {
        this.editedCustomerRepairItemIndex = -1
      })
    },
    setEditedItem (val) {
      this.editedCustomerRepairItem = JSON.parse(JSON.stringify(val))
      this.editedCustomerRepairItem.ItemId = this.editedCustomerRepairItem.Id
      this.editedCustomerRepairItem.RepairWarrantyPeriod = val.WarrantyPeriod
      this.editedCustomerRepairItem.RepairPrice = val.Price
      this.editedCustomerRepairItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedCustomerRepairItem.Price = val.Price
      if (val.OldItemId) {
        this.editedCustomerRepairItem.OldRepairWarrantyPeriod = val.OldWarrantyPeriod
        this.editedCustomerRepairItem.OldWarrantyPeriod = val.OldWarrantyPeriod
        this.turnOldRepairPrice()
        this.turnOldPrice()
      }
    },
    turnOldRepairPrice () {
      if (this.editedCustomerRepairItem.OldNumber) {
        this.editedCustomerRepairItem.OldRepairPrice = Math.round(
          this.editedCustomerRepairItem.RepairPrice * 0.8
        )
      }
    },
    turnOldPrice () {
      if (this.editedCustomerRepairItem.OldNumber) {
        this.editedCustomerRepairItem.OldPrice = Math.round(
          this.editedCustomerRepairItem.Price * 0.8
        )
      }
    }
  }
}
</script>
